import { FC, useState } from 'react';
import {
    Box,
    Button,
    FormControl,
    FormControlLabel,
    FormLabel,
    Radio,
    RadioGroup,
    Slider,
    Stack,
    TextField,
    Typography,
} from '@mui/material';
import { AiTopicDifficulty } from '../../../models/word/aiVocabModels';

interface Props {
    onBack: () => void;
    onSubmit: (params: { topic: string; wordCount: number; difficulty: AiTopicDifficulty }) => void;
}

export const StepTopicInput: FC<Props> = ({ onBack, onSubmit }) => {
    const [topic, setTopic] = useState('');
    const [wordCount, setWordCount] = useState(20);
    const [difficulty, setDifficulty] = useState<AiTopicDifficulty>('EASY');

    const trimmed = topic.trim();
    const canSubmit = trimmed.length > 0 && trimmed.length <= 200;

    return (
        <Stack spacing={3} sx={{ pt: 1 }}>
            <TextField
                label="주제"
                placeholder="예: airport, business meeting"
                value={topic}
                onChange={(e) => setTopic(e.target.value)}
                fullWidth
                inputProps={{ maxLength: 200 }}
                helperText={`${trimmed.length} / 200`}
                autoFocus
            />
            <Box>
                <Typography gutterBottom>단어 개수: {wordCount}</Typography>
                <Slider
                    value={wordCount}
                    onChange={(_, v) => setWordCount(v as number)}
                    min={5}
                    max={50}
                    step={5}
                    marks
                    valueLabelDisplay="auto"
                />
            </Box>
            <FormControl>
                <FormLabel>난이도</FormLabel>
                <RadioGroup
                    row
                    value={difficulty}
                    onChange={(e) => setDifficulty(e.target.value as AiTopicDifficulty)}
                >
                    <FormControlLabel value="EASY" control={<Radio />} label="쉬움" />
                    <FormControlLabel value="NORMAL" control={<Radio />} label="보통" />
                    <FormControlLabel value="HARD" control={<Radio />} label="어려움" />
                </RadioGroup>
            </FormControl>
            <Box display="flex" justifyContent="space-between" pt={1}>
                <Button onClick={onBack}>뒤로</Button>
                <Button
                    variant="contained"
                    disabled={!canSubmit}
                    onClick={() => onSubmit({ topic: trimmed, wordCount, difficulty })}
                >
                    다음
                </Button>
            </Box>
        </Stack>
    );
};
